<template>
  <label class="checkbox" :class="selector">
    <input type="checkbox"
           :checked="checked"
           @click="onInput">
    <span class="checkbox__mark"
          :style="markStyle">
        <slot name="ico">
          <BaseSvg name="ico-check"/>
        </slot>
        <slot name="tooltip">
        </slot>
      </span>
    <slot name="label" class="checkbox__text">
      <span v-if="label && route"
            @click.capture.prevent="onClick(!checked)"
            class="checkbox__text">
        <span v-if="isAttributeTrue($attrs.required)" class="input__required">*</span>
        <router-link-modified :to="route">
          {{label}}
        </router-link-modified>
      </span>
      <span v-else-if="label" class="checkbox__text">
        <span v-if="isAttributeTrue($attrs.required)" class="input__required">*</span>
        {{label}}
      </span>
    </slot>
  </label>
</template>

<script>
  export default {
    model: {
      prop: 'checked'
    },
    props: {
      id: {
        type: [Boolean, Number],
      },
      checked: {
        type: [Boolean, Array],
        default: false
      },
      label: {
        type: String
      },
      color: String,
      route: [String, Object]
    },
    data() {
      return {}
    },
    computed: {
      selector() {
        let selector = ''
        if (this.checked) selector = selector + ' _checked '
        return selector
      },
      markStyle() {
        if (!this.color) return null
        return {
          borderColor: this.color,
          backgroundColor: this.checked ? this.color : null
        }
      }
    },
    methods: {
      onInput(event) {
        this.$emit('input', event.target.checked, this.id)
      },
      onClick(event) {
        this.$emit('input', event)
      },
      isAttributeTrue(attr) {
        return attr || attr === ''
      }
    }
  }
</script>

<style lang="less">

</style>
